import styled from 'styled-components';

export const PaginationCover = styled.div`
  .pagination {
    /* position: fixed;
        bottom: 0;
        left: 0; */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: white;
    padding: 20px 0;

    @media (max-width: 720px) {
      padding: 20px 0px 60px 0px;
    }
  }
  .pageClassName,
  .previous,
  .next {
    width: clamp(34px, 4vw, 48px);
    height: clamp(34px, 4vw, 48px);
    line-height: clamp(34px, 4vw, 48px);
    margin: 0 12px;
    background-color: #f5f5f5;
    text-align: center;
    font-weight: 500;
    font-size: clamp(14px, 2vw, 16px);
    color: hsl(0deg, 0%, 0%, 60%);
    border-radius: 4px;
    cursor: pointer;
    transition:
      transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
      box-shadow 0.3s ease 0s;
    a {
      width: clamp(34px, 4vw, 48px);
      height: clamp(34px, 4vw, 48px);
      display: inline-block;
    }

    @media (max-width: 720px) {
      margin: 0 8px;
      cursor: default;
    }

    &:hover {
      background-color: #f1f1f1;
      transform: scale(1.03);
    }

    &.selected {
      background-color: #63b0a8;
    }
  }

  .disabled,
  .break {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed !important;
  }
  .activeClass {
    color: #fff;
    cursor: default;
  }
`;
